import { stateOptions } from '../commonStateTaxData';

export const step1Questions = [
  {
    id: 'employee_name',
    title: 'Full name',
    is_required: true,
    question_type: 'short_text',
  },
  {
    id: 'employee_ssn',
    title: 'Social Security number',
    is_required: true,
    placeholder: '9 digits',
    question_type: 'identity',
    identity_type: 'ssn',
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: '^\\d{9}$',
      },
    ],
  },
  {
    id: 'street_address',
    title: 'Home address',
    is_required: true,
    question_type: 'short_text',
  },
  {
    id: 'city_or_town',
    title: 'City or town',
    is_required: true,
    question_type: 'short_text',
  },
  {
    id: 'state',
    title: 'State',
    is_required: true,
    question_type: 'dropdown',
    options: stateOptions,
  },
  {
    id: 'zip_code',
    title: 'Zip code',
    is_required: true,
    question_type: 'short_text',
    placeholder: '5 digits',
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: '^\\d{5}$',
      },
    ],
  },
];

export const filingStatusInitialQuestion = [
  {
    id: 'filing_status',
    title: 'Select the appropriate filing status:',
    is_required: true,
    question_type: 'long_multiple_choice',
    options: [
      {
        codeValue: 'single_or_married',
        shortName: 'Single or married spouse works or married filing separately',
      },
      {
        codeValue: 'married',
        shortName: 'Married (spouse does not work)',
      },
      {
        codeValue: 'head_of_household',
        shortName: 'Head of Household',
      },
    ],
  },
];
